module.exports = __webpack_public_path__ + "static/assets/fdf3c9ffc3f2162f20d1eccc462c44b4.svg";